import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { Autoplay, Controller } from 'swiper/modules';

domReady(() => {
  const blocks = document.querySelectorAll('.partners-logos-block');

  blocks.forEach((block) => {
    const trackEls = block.querySelectorAll('.partners-logos__track .swiper');

    if (!trackEls.length) return;

    // slidesPerView capped at half of total slides (guarantees total > loopAdditionalSlides)
    function spv(bpSPV, total) {
      return Math.min(bpSPV, Math.floor((total - 2) / 2));
    }

    function makeConfig(trackEl) {
      const total = trackEl.querySelectorAll('.swiper-slide').length;
      const spvDesktop = spv(7, total);

      return {
        modules: [Autoplay, Controller],
        slidesPerView: spv(3, total),
        slidesPerGroup: 1,
        spaceBetween: 20,
        speed: 600,
        loop: true,
        loopPreventsSliding: false,
        loopAdditionalSlides: spvDesktop * 2 + 1,
        breakpoints: {
          768: { slidesPerView: spv(5, total) },
          1080: { slidesPerView: spvDesktop },
        },
      };
    }

    if (trackEls.length === 1) {
      new Swiper(trackEls[0], {
        ...makeConfig(trackEls[0]),
        autoplay: { delay: 3000, disableOnInteraction: false },
      });
      return;
    }

    // Two tracks — autoplay only on swiper1, controller drives swiper2
    const swiper1 = new Swiper(trackEls[0], {
      ...makeConfig(trackEls[0]),
      autoplay: { delay: 3000, disableOnInteraction: false },
    });

    function applyTrack2Offset(swiper) {
      const slideWidth = swiper.slidesSizesGrid[0] || 0;
      swiper.params.slidesOffsetBefore = -Math.round(slideWidth / 3);
      swiper.update();
    }

    const swiper2 = new Swiper(trackEls[1], {
      ...makeConfig(trackEls[1]),
      on: {
        afterInit: applyTrack2Offset,
        breakpoint: applyTrack2Offset,
      },
    });

    swiper1.controller.control = swiper2;
    swiper2.controller.control = swiper1;

    // Pause swiper1 on hover of either track — swiper2 stops naturally since
    // it has no autoplay and the controller no longer drives it
    block.addEventListener('mouseenter', () => swiper1.autoplay.pause());
    block.addEventListener('mouseleave', () => swiper1.autoplay.resume());
  });
});
